import { Config } from '@adornis/config/config';

export const config = new Config('wtg', {
  NODEBB_DOMAIN: {
    required: true,
    client: true,
    env: true,
    name: 'NODEBB_DOMAIN',
  },
  ADMIN_MAIL: {
    required: true,
    env: true,
    name: 'ADMIN_MAIL',
    client: true,
  },
});
